import React from "react";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import "./dateFilter.css";
import * as XLSX from "xlsx";


const DateFilter = ({
  bookingList,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  setSnackbarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
  handleFilterBookings,
  handleReset,
}) => {


  const exportToExcel = () => {
    const newBookingList = bookingList.map(
      ({ booked_at, booked_payment_id, created_at, geo_location, location, service_id, user, final_payment_id, worker, ...rest }) => rest
    );
    const worksheet = XLSX.utils.json_to_sheet(newBookingList);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "bookingDetails");
    XLSX.writeFile(workbook, "bookingDetails.xlsx");

    setSnackbarMessage("Excel sheet downloaded successfully.");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
  };

  

  return (
    <div>
      <div className="download-excel mt-2">
        <div className="date-picker">
          <input
            className="date-input"
            type="date"
            value={startDate}
            onChange={(e) =>{
              setStartDate(e.target.value)
            }}
            placeholder="Start Date"
          />
          <div className="range">-</div>

          <input
            className="date-input"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            placeholder="End Date"
            min={startDate}
          />
        </div>
        <div className="date-picker-btns">
          <button className="filter-btn" onClick={()=>handleFilterBookings()}>
            Apply Range
          </button>
          <button className="reset-btn" onClick={handleReset}>
            Reset
          </button>

          <Button variant="contained" color="primary" onClick={exportToExcel}>
            <DownloadIcon /> Download
          </Button>
        </div>
      </div>
      
    </div>
  );
};

export default DateFilter;
